import config from "./config"

// eslint-disable-next-line
export const PRODUCTION_ENV = config.env === 'production'

